import { render } from "./BaseTutorialModal.vue?vue&type=template&id=3527a787&scoped=true"
import script from "./BaseTutorialModal.vue?vue&type=script&lang=js"
export * from "./BaseTutorialModal.vue?vue&type=script&lang=js"

import "./BaseTutorialModal.vue?vue&type=style&index=0&id=3527a787&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3527a787"]])

export default __exports__